import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.visible = $event)),
    title: "增加应用分类",
    afterClose: _ctx.afterClose,
    onCancel: _ctx.afterClose,
    onOk: _ctx.handleOk,
    loading: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_input, {
        value: _ctx.name,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
        placeholder: "请输入应用类型"
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["visible", "afterClose", "onCancel", "onOk", "loading"]))
}